<template>
  <div class="ui-container">
    <h2>Table</h2>
    <div class="ui-block">
      <Table
        :fields="tableFields"
        :data="tableData"
        :itemsPerPage="2"
        style="height: 250px"
      >
        <template #actions>
          <Button class="secondary icon" icon="bi bi-eye" label="Voir" />
        </template>
      </Table>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const tableFields = ref([
  {
    id: "id",
    label: "#",
  },
  {
    id: "participant",
    label: "Participant",
    template(value) {
      return `<div class="container"><img class="picture rond" src="/images/defaults/user/lemon-yellow.png"" alt="picture"/>${value}</div>`;
    },
  },
  {
    id: "campaign",
    label: "Campaign",
  },
  {
    id: "campaign_status",
    label: "Statut",
    template(value) {
      return `<div class="tag yellow-light">${value}</div>`;
    },
  },
  {
    id: "campaign_date",
    label: "Date",
  },
]);

const tableData = ref([
  {
    id: 1,
    participant: "Hannah Morgan",
    campaign: "Web developer",
    campaign_status: "Dashboard",
    campaign_date: "16/12/2022 - 10:35",
  },
  {
    id: 2,
    participant: "Hannah Morgan",
    campaign: "Web developer",
    campaign_status: "Dashboard",
    campaign_date: "16/12/2022 - 10:35",
  },
  {
    id: 3,
    participant: "Hannah Morgan",
    campaign: "Web developer",
    campaign_status: "Dashboard",
    campaign_date: "16/12/2022 - 10:35",
  },
]);

const tableActions = ref([
  {
    class: "secondary",
    icon: "bi bi-eye",
    route: {
      name: "home",
    },
  },
  {
    class: "primary",
    icon: "bi bi-pencil-square",
    route: {
      name: "home",
    },
  },
]);
</script>
